import { documentSetCookie } from '../cookie';

export const SETTINGS_NIGHTMODE = 'settings/NIGHTMODE';
export const SETTINGS_NSFW_FILTER = 'settings/NSFW_FILTER';
export const SETTINGS_UP_NEXT = 'settings/UP_NEXT';
export const SETTINGS_MEDIA_FILTER = 'settings/MEDIA_FILTER';
export const SETTINGS_WIDE_COMMENTS = 'settings/WIDE_COMMENTS';
export const SETTINGS_COMMENTS_UNDER_VIDEO = 'settings/COMMENTS_UNDER_VIDEO';
export const SETTINGS_HIGHLIGHT_VIEWED = 'settings/HIGHLIGHT_VIEWED';
export const SETTINGS_SEARCH_DEFAULT_SORT = 'settings/SEARCH_RESULT_SORT';
export const SETTINGS_SEARCH_AVAILABLE_SORTING = 'settings/SEARCH_AVAILABLE_SORTING';
export const SETTINGS_FLOPPERS_DEFAULT_SORT = 'settings/FLOPPERS_DEFAULT_SORT';
export const SETTINGS_FLOPPERS_AVAILABLE_SORTING = 'settings/FLOPPERS_AVAILABLE_SORTING';
export const SETTINGS_RELATED_LIST_TYPE = 'settings/RELATED_LIST_TYPE';

export const settingsInitialState = {
  nightMode: true,
  loggedIn: false,
  showNsfw: false,
  upNext: false,
  showMedia: '',
  wideComments: false,
  commentsUnderVideo: false,
  highlightViewed: true,
  searchDefaultSort: 'date',
  searchAvailableSorting: [
    { sorting: 'date', label: 'Nieuwste'},
    { sorting: 'date-', label: 'Oudste' },
    { sorting: 'kudos', label: 'Meeste kudos' },
    { sorting: 'kudos-', label: 'Minste kudos' },
    { sorting: 'relevance', label: 'Relevantie' },
  ],
  floppersDefaultSort: 'kudos-',
  floppersAvailableSorting: [
    { sorting: 'date', label: 'Nieuwste' },
    { sorting: 'date-', label: 'Oudste' },
    { sorting: 'kudos', label: 'Meeste kudos' },
    { sorting: 'kudos-', label: 'Minste kudos' },
  ], 
  relatedListType: 'latest', 
};

export const changeNightModeAction = () => ({ type: SETTINGS_NIGHTMODE });
export const changeNsfwAction = payload => ({ type: SETTINGS_NSFW_FILTER, payload });
export const changeUpNextAction = payload => ({ type: SETTINGS_UP_NEXT, payload });
export const changeMediaFilterAction = payload => ({ type: SETTINGS_MEDIA_FILTER, payload });
export const changeWideCommentsAction = payload => ({ type: SETTINGS_WIDE_COMMENTS, payload });
export const changeCommentsUnderVideoAction = payload => ({ type: SETTINGS_COMMENTS_UNDER_VIDEO, payload });
export const changeHighlightViewedAction = () => ({ type: SETTINGS_HIGHLIGHT_VIEWED });
export const changeSearchDefaultSort = payload => ({ type: SETTINGS_SEARCH_DEFAULT_SORT, payload });
export const changeFloppersDefaultSort = payload => ({ type: SETTINGS_FLOPPERS_DEFAULT_SORT, payload });
export const changeRelatedListTypeAction = payload => ({ type: SETTINGS_RELATED_LIST_TYPE, payload });

export const changeMediaFilterClientPersistent = filterValue => dispatch => {
  documentSetCookie('filterMedia', filterValue);
  dispatch(changeMediaFilterAction(filterValue));
};

export const changeUpNextClientPersistent = value => dispatch => {
  documentSetCookie('upNext', value);
  dispatch(changeUpNextAction(value));
};

export const changeCommentsUnderVideoPersistent = value => dispatch => {
  documentSetCookie('commentsUnderVideo', value);
  dispatch(changeCommentsUnderVideoAction(value));
};


export const changeRelatedListTypePersistent = value => dispatch => {
  documentSetCookie('relatedListType', value);
  dispatch(changeRelatedListTypeAction(value));
};

export const settingsReducer = (state = settingsInitialState, action) => {
  switch (action.type) {
  case SETTINGS_NIGHTMODE:
    return {
      ...state,
      nightMode: !state.nightMode,
    };
  case SETTINGS_NSFW_FILTER:
    return {
      ...state,
      showNsfw: action.payload,
    };
  case SETTINGS_UP_NEXT:
    return {
      ...state,
      upNext: action.payload,
    };
  case SETTINGS_MEDIA_FILTER:
    return {
      ...state,
      showMedia: action.payload,
    };
  case SETTINGS_WIDE_COMMENTS:
    return {
      ...state,
      wideComments: action.payload,
    };
  case SETTINGS_COMMENTS_UNDER_VIDEO:
    return {
      ...state,
      commentsUnderVideo: action.payload,
    };    
  case SETTINGS_HIGHLIGHT_VIEWED:
    return {
      ...state,
      highlightViewed: !state.highlightViewed,
    };
  case SETTINGS_SEARCH_DEFAULT_SORT:
    return {
      ...state,
      searchDefaultSort: action.payload,
    };
  case SETTINGS_SEARCH_AVAILABLE_SORTING:
    return {
      ...state,
      searchAvailableSorting: action.payload,
    };
  case SETTINGS_FLOPPERS_DEFAULT_SORT:
    return {
      ...state,
      floppersDefaultSort: action.payload,
    };
  case SETTINGS_FLOPPERS_AVAILABLE_SORTING:
    return {
      ...state,
      floppersAvailableSorting: action.payload,
    };    
  case SETTINGS_RELATED_LIST_TYPE:
    return {
      ...state,
      relatedListType: action.payload,
    }; 
  default:
    return state;
  }
};

export const selectNightMode = state => state.settings.nightMode;
export const selectShowNsfw = state => state.settings.showNsfw;
export const selectUpNext = state => state.settings.upNext;
export const selectShowMedia = state => state.settings.showMedia;
export const selectWideComments = state => state.settings.wideComments;
export const selectCommentsUnderVideo = state => state.settings.commentsUnderVideo;
export const selectHighlightViewed = state => state.settings.highlightViewed;
export const selectSearchDefaultSort = state => state.settings.searchDefaultSort;
export const selectSearchAvailableSorting = state => state.settings.searchAvailableSorting;
export const selectFloppersDefaultSort = state => state.settings.floppersDefaultSort;
export const selectFloppersAvailableSorting = state => state.settings.floppersAvailableSorting;
export const selectRelatedListType = state => state.settings.relatedListType;
